import React from 'react';
import './SmartXonnectUsage.scss';
import TopLeft from '../../../../assets/smartxonnect/top-left.webp';
import PlanYourRide from '../../../../assets/smartxonnect/plan-your-ride.webp';
import OnRideCompanion from '../../../../assets/smartxonnect/on-ride-companion.webp';
import AlwaysConnected from '../../../../assets/smartxonnect/always-connected.webp';
import ArrowWeb from '../../../../assets/smartxonnect/arrow-web.webp';
import ArrowMobile from '../../../../assets/smartxonnect/arrow-mobile.webp';
const MediaHighlight = () => {
  const steps = [
    {
      label: 'Plan Your Ride',
      position: 0,
      image: PlanYourRide,
      image1: { web: ArrowWeb },
    },
    {
      label: 'On Ride Companion',
      position: 50,
      image: OnRideCompanion,
      image1: { web: ArrowWeb },
    },
    {
      label: 'Always Connected',
      position: 100,
      image: AlwaysConnected,
      image1: { web: ArrowWeb },
    },
  ];

  return (
    <>
      <div className="position-relative">
        <div className="media-highlight" data-aos="fade-up">
          {/* <h2 className="title roboto-bold">Usage of SmartXonnect</h2> */}
          <div className="timeline">
            {/* <div className="line"></div> */}
            {steps.map((step, index) => (
              <>
                <div key={index} className="step" style={{ left: `${step.position}%` }}>
                  <div className="step-image">
                    <img src={step.image} alt={step.label} />
                  </div>
                  <div className="step-info">
                    <div className="dot">{index + 1}</div>
                    <div className="label roboto-regular">{step.label}</div>
                  </div>
                  {index !== 2 && step.image1 && (
                    <div className="step-image web-arrow">
                      <img src={step.image1.web} alt={step.label} />
                    </div>
                  )}
                </div>
                <div className="step-image mobile-arrow">
                  <img src={ArrowMobile} />
                </div>
              </>
            ))}
          </div>
        </div>
        <div className="info-styleright">
          <img src={TopLeft} alt="Info Style Top Left" className="top-left" />
        </div>
      </div>
    </>
  );
};

export default React.memo(MediaHighlight);
